import HeadingSection from 'app/ui/components/heading-section/HeadingSection';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Container } from '@mui/material';

function Error404Page() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      <Container maxWidth="lg">
        <Box mt={-6} color="#fff">
          <HeadingSection title="Page not found" />
        </Box>

        <Box display="flex" justifyContent="center" mt={5}>
          <Button variant="contained" disableElevation component={RouterLink} to="/dashboard" color="secondary">
            Back to Dashboard
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Error404Page;
